import PropTypes from 'prop-types';
import cx from 'classnames';
import stylesModule from '../../../../summary-and-payment/styles.module.scss';
import { useTranslation } from 'react-i18next';

const ItemsInOrderTableNotes = ({
  customerPartNumber,
  customerSerialNumber,
  lineItemNo,
  partNote
}) => {
  const [t] = useTranslation();
  const notesList = [
    {
      key: 'customerSerialNumber',
      value: customerSerialNumber,
      translationKey: 'ASSET_ID_ESN_PLACEHOLDER'
    },
    {
      key: 'partNote',
      value: partNote,
      translationKey: 'CAT_ORDER_LINE_ITEM_NO_PLACEHOLDER'
    },
    {
      key: 'customerPartNumber',
      value: customerPartNumber,
      translationKey: 'CAT_ORDER_CPART_NUMBER_PLACEHOLDER'
    },
    {
      key: 'lineItemNo',
      value: lineItemNo,
      translationKey: 'CAT_ORDER_CUST_ITEM_NO_PLACEHOLDER'
    }
  ];
  return (
    <>
      {notesList?.map(
        note =>
          note.value && (
            <div key={note.key}>
              <span
                className={cx(
                  'm-0 mb-2 text-sm u-color--DarkGray',
                  stylesModule['text-print-md']
                )}
              >
                <b>{t(note.translationKey)}: </b>
              </span>
              <span
                className={cx(
                  'exclude-global u-color--DarkGray',
                  stylesModule['text-print-md']
                )}
              >
                {note.value}
              </span>
              <br />
            </div>
          )
      )}
    </>
  );
};

ItemsInOrderTableNotes.propTypes = {
  customerPartNumber: PropTypes.string,
  customerSerialNumber: PropTypes.string,
  lineItemNo: PropTypes.string,
  partNote: PropTypes.string
};

export default ItemsInOrderTableNotes;
